import React from 'react';
import { UserEntityBadge } from 'components/Global/Badges/';
import Box from '@bit/knotchinc.web-react-components.box';
import { numberWithCommas } from 'helpers/Utils.js';
import {
  LeaderboardSection,
  SharedInfo,
  StyledSharedIcon,
  Logo,
  Badge,
  Name,
  Value,
  ValueContainer,
  ValueDesc,
} from './styled.js';

const descByType = {
  social: 'Shares',
  content: 'Content Pieces',
  entity: 'Content Pieces',
};

const validateEntityData = data => !!(data.public_id && data.logo_url && data.num_contents && data.name);
const validateSocialData = data => !!(data.public_id && data.logo_url && data.num_shares && data.name);

const validationMap = {
  entity: validateEntityData,
  content: validateEntityData,
  social: validateSocialData,
};

const EntityLeaderboardBlock = ({
  reportType,
  type,
  data = {},
  position,
}) => {
  const { name, logo_url, num_contents, num_in_common, num_shares } = data;

  const validatedData = validationMap[type](data);

  if (!validatedData) {
    return (
      <LeaderboardSection noData>
        <Box height="100px" pt="35px" pl="31px">
          <Logo>{position > 0 ? <Badge>{position}</Badge> : null}</Logo>
          <Name>
            {name || 'No Data returned'}
            {name && position === 0 && type !== 'entity' ? <UserEntityBadge /> : null}
          </Name>
          <ValueContainer>
            <Value>--</Value>
            <ValueDesc>{descByType[type]}</ValueDesc>
          </ValueContainer>
        </Box>
        {type === 'entity' && position === 0 ? <SharedInfo>{`No results for your top ${reportType === 'brand' ? 'publisher' : 'brand'}`}</SharedInfo> : null}
        {type === 'entity' && position > 0 ? <SharedInfo>No results found</SharedInfo> : null}
      </LeaderboardSection>
    );
  }

  return (
    <LeaderboardSection>
      <Box height="100px" pt="35px" pl="31px">
        <Logo logo_url={logo_url}>{position > 0 ? <Badge>{position}</Badge> : null}</Logo>
        {position === 0 && type !== 'entity' ? (
          <Name>
            {name}
            <UserEntityBadge />
          </Name>
        ) : (
          <Name>{name}</Name>
        )}
        <ValueContainer>
          <Value>{type === 'social' ? numberWithCommas(num_shares) : numberWithCommas(num_contents)}</Value>
          <ValueDesc>{descByType[type]}</ValueDesc>
        </ValueContainer>
      </Box>
      {type === 'entity' && position === 0 ? <SharedInfo>{`Your top ${reportType === 'brand' ? 'publisher' : 'brand'} partner`}</SharedInfo> : null}
      {type === 'entity' && position > 0 ? (
        <SharedInfo>
          <StyledSharedIcon />
          Common amongst <span>{num_in_common}</span> {`${reportType}s`}
        </SharedInfo>
      ) : null}
    </LeaderboardSection>
  );
};

export default EntityLeaderboardBlock;
